module.exports = __webpack_public_path__ + "static/media/kkkkkkkkkk.87223f42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/kkkkkkkkkk.jpg
// module id = 377
// module chunks = 0